<template>
 <svg :style="style"  width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_4253_85380)">
<path id="Vector" d="M10.3203 8.77109C13.7908 7.45548 16.2393 7.8627 17.6659 9.99225C19.8057 13.1871 18.23 16.0774 16.9866 16.0774C15.7428 16.0774 15.2483 16.0774 15.2483 13.6748C15.2483 12.0733 13.6055 10.4387 10.3203 8.77109Z" fill="white" fill-opacity="0.2"/>
<path id="Vector_2" d="M10.3213 0.79152C10.3213 0.654634 10.2669 0.523354 10.1702 0.426561C10.0734 0.329768 9.94208 0.275391 9.80519 0.275391C9.66831 0.275391 9.53703 0.329768 9.44023 0.426561C9.34344 0.523354 9.28906 0.654634 9.28906 0.79152V4.31565C9.28896 4.40685 9.31303 4.49645 9.35881 4.57532C9.4046 4.6542 9.47046 4.71954 9.54971 4.76468L12.8091 6.61862C12.8869 6.66294 12.975 6.68625 13.0645 6.68623C15.8465 6.68623 17.7835 7.31075 18.904 8.52365C20.023 9.73552 20.4849 11.7562 20.2491 14.6083C20.2458 14.6489 20.2474 14.6898 20.2537 14.7301L21.4305 22.3022C21.4536 22.4356 21.5281 22.5546 21.638 22.6335C21.748 22.7125 21.8845 22.7451 22.0183 22.7243C22.152 22.7035 22.2723 22.631 22.3531 22.5224C22.4339 22.4138 22.4688 22.2779 22.4504 22.1438L21.2829 14.6315C21.528 11.5502 21.0011 9.27358 19.6622 7.82378C18.3358 6.38739 16.1742 5.67565 13.2018 5.65449L10.3213 4.01578V0.79152ZM21.2772 14.6935L21.2731 14.5716L21.2824 14.6315L21.2772 14.6935ZM17.1827 28.3822C17.2304 28.5075 17.325 28.6093 17.4463 28.6661C17.5677 28.7229 17.7065 28.7302 17.8332 28.6866C17.9599 28.643 18.0647 28.5517 18.1253 28.4322C18.186 28.3127 18.1978 28.1743 18.1582 28.0462L15.0367 18.9794C14.8736 18.5046 14.1974 18.519 14.054 19L12.2558 25.0382C12.2417 25.086 12.2345 25.1355 12.2346 25.1853V31.4873C12.2346 31.6241 12.289 31.7554 12.3858 31.8522C12.4826 31.949 12.6139 32.0034 12.7507 32.0034C12.8876 32.0034 13.0189 31.949 13.1157 31.8522C13.2125 31.7554 13.2669 31.6241 13.2669 31.4873V25.2612L14.5845 20.8364L17.1827 28.3827V28.3822Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4253_85380">
<rect width="32" height="32" fill="white" transform="translate(0 0.275391)"/>
</clipPath>
</defs>
</svg>



</template>

<script>
export default {
  name: 'icon-jbjb',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>